// src/routes/routes.js

// Import your layouts and pages lazily
const DashboardLayout = () => import('@/views/Layout/DashboardLayout.vue');
const AuthLayout      = () => import('@/views/Pages/AuthLayout.vue');
const NotFound        = () => import('@/views/NotFoundPage.vue');

export default [
  // ——— Public (Auth) routes under /auth ———
  {
    path: '/auth',
    component: AuthLayout,
    redirect: '/auth/login',
    children: [
      {
        path: 'login',
        name: 'login',
        component: () => import('@/views/Pages/Login.vue')
      },
      {
        path: 'register',
        name: 'register',
        component: () => import('@/views/Pages/Register.vue')
      },
      {
        path: 'request-password-reset',
        name: 'request-password-reset',
        component: () => import('@/views/Pages/RequestPasswordReset.vue')
      },
      {
        path: 'forgot-password/:token',
        name: 'forgot-password',
        component: () => import('@/views/Pages/ForgotPassword.vue')
      },
      {
        path: 'registro-comprador/:codigo',
        name: 'registro-comprador',
        component: () => import('@/views/Pages/RegistroCompradorView.vue')
      }
    ]
  },

  // ——— Protected routes under root ———
  {
    path: '/',
    component: DashboardLayout,
    redirect: () => {
      try {
        const { jwtDecode } = require('jwt-decode');
        const token = localStorage.getItem('user-session');
        if (token) {
          const decoded = jwtDecode(token);
          const rol = (decoded.rol || '').toLowerCase().trim();
          if (rol === 'comprador') return '/visor-transacciones';
        }
      } catch {}
      return '/dashboard-master';
    },
    children: [
      {
        path: 'inventario',
        name: 'inventario',
        component: () => import('@/views/Inventario.vue'),
        meta: { requiresAuth: true, roles: ['visita', 'admin','ventas inex','operaciones','cliente'] }
      }
      ,
      {
        path: 'depuracion-modelo',
        name: 'depuracion-modelo',
        component: () => import('@/views/DepuracionModelo/DepuracionModeloView.vue'),
        meta: { requiresAuth: true, roles: ['visita', 'admin', 'operaciones'] }
      },
      {
        path: 'traduccion-revision',
        name: 'traduccion-revision',
        component: () => import('@/views/TraduccionRevision.vue'),
        meta: { requiresAuth: true, roles: ['visita', 'admin','ventas inex','operaciones'] }
      }
      ,
      {
        path: 'analytics',
        name: 'analytics',
        component: () => import('@/views/Dashboard/AnalyticsDashboard.vue'),
        meta: { requiresAuth: true, roles: ['visita', 'admin'] }
      },
      {
        path: 'log-process',
        name: 'log-process',
        component: () => import('@/views/LogStatus/LogStatusView.vue'),
        meta: { requiresAuth: true, roles: ['visita', 'admin'] }
      },
      {
        path: 'dashboard-master',
        name: 'dashboard-master',
        component: () => import('@/views/DashboardMaster/index.vue'),
        meta: { requiresAuth: true, roles: ['visita', 'admin', 'ventas inex', 'operaciones', 'cliente'], hideLayoutHeader: true }
      },
      {
        path: 'usuarios',
        name: 'usuarios',
        component: () => import('@/views/Usuario/UsuarioView.vue'),
        meta: { requiresAuth: true, roles: ['visita', 'admin','operaciones'] }
      },
      {
        path: 'usuarios/crear',
        name: 'usuario-crear',
        component: () => import('@/views/Usuario/UsuarioCrear.vue'),
        meta: { requiresAuth: true, roles: ['admin','operaciones'] }
      },
      {
        path: 'usuarios/detalle/:id',
        name: 'usuario-detalle',
        component: () => import('@/views/Usuario/UsuarioDetalle.vue'),
        meta: { requiresAuth: true, roles: ['visita', 'admin','operaciones'] }
      },
      // ——— Mantenedores: Paises / Regiones / Comunas / Bodegas ———
      {
        path: 'paises',
        name: 'paises',
        component: () => import('@/views/Pais/PaisView.vue'),
        meta: { requiresAuth: true, roles: ['visita', 'admin','operaciones','ventas inex'] }
      },
      {
        path: 'paises/crear',
        name: 'pais-crear',
        component: () => import('@/views/Pais/PaisCrear.vue'),
        meta: { requiresAuth: true, roles: ['admin','operaciones'] }
      },
      {
        path: 'paises/detalle/:id',
        name: 'pais-detalle',
        component: () => import('@/views/Pais/PaisDetalle.vue'),
        meta: { requiresAuth: true, roles: ['visita', 'admin','operaciones','ventas inex'] }
      },
      {
        path: 'regiones',
        name: 'regiones',
        component: () => import('@/views/Region/RegionView.vue'),
        meta: { requiresAuth: true, roles: ['visita', 'admin','operaciones','ventas inex'] }
      },
      {
        path: 'regiones/crear',
        name: 'region-crear',
        component: () => import('@/views/Region/RegionCrear.vue'),
        meta: { requiresAuth: true, roles: ['admin','operaciones'] }
      },
      {
        path: 'regiones/detalle/:id',
        name: 'region-detalle',
        component: () => import('@/views/Region/RegionDetalle.vue'),
        meta: { requiresAuth: true, roles: ['visita', 'admin','operaciones','ventas inex'] }
      },
      {
        path: 'comunas',
        name: 'comunas',
        component: () => import('@/views/Comuna/ComunaView.vue'),
        meta: { requiresAuth: true, roles: ['visita', 'admin','operaciones','ventas inex'] }
      },
      {
        path: 'comunas/crear',
        name: 'comuna-crear',
        component: () => import('@/views/Comuna/ComunaCrear.vue'),
        meta: { requiresAuth: true, roles: ['admin','operaciones'] }
      },
      {
        path: 'comunas/detalle/:id',
        name: 'comuna-detalle',
        component: () => import('@/views/Comuna/ComunaDetalle.vue'),
        meta: { requiresAuth: true, roles: ['visita', 'admin','operaciones','ventas inex'] }
      },
      {
        path: 'bodegas',
        name: 'bodegas',
        component: () => import('@/views/Bodega/BodegaView.vue'),
        meta: { requiresAuth: true, roles: ['visita', 'admin','operaciones','ventas inex'] }
      },
      {
        path: 'bodegas/crear',
        name: 'bodega-crear',
        component: () => import('@/views/Bodega/BodegaCrear.vue'),
        meta: { requiresAuth: true, roles: ['admin','operaciones'] }
      },
      {
        path: 'bodegas/detalle/:id',
        name: 'bodega-detalle',
        component: () => import('@/views/Bodega/BodegaDetalle.vue'),
        meta: { requiresAuth: true, roles: ['visita', 'admin','operaciones','ventas inex'] }
      },
      // ——— Mantenedores 2: Unidades de Medida / Condiciones / Taxonomías / Imágenes Categorías ———
      {
        path: 'unidades-medida',
        name: 'unidades-medida',
        component: () => import('@/views/UnidadMedida/UnidadMedidaView.vue'),
        meta: { requiresAuth: true, roles: ['visita', 'admin','operaciones','ventas inex'] }
      },
      {
        path: 'unidades-medida/crear',
        name: 'unidad-medida-crear',
        component: () => import('@/views/UnidadMedida/UnidadMedidaCrear.vue'),
        meta: { requiresAuth: true, roles: ['admin','operaciones'] }
      },
      {
        path: 'unidades-medida/detalle/:id',
        name: 'unidad-medida-detalle',
        component: () => import('@/views/UnidadMedida/UnidadMedidaDetalle.vue'),
        meta: { requiresAuth: true, roles: ['visita', 'admin','operaciones','ventas inex'] }
      },
      {
        path: 'condiciones',
        name: 'condiciones',
        component: () => import('@/views/Condicion/CondicionView.vue'),
        meta: { requiresAuth: true, roles: ['visita', 'admin','operaciones','ventas inex'] }
      },
      {
        path: 'condiciones/crear',
        name: 'condicion-crear',
        component: () => import('@/views/Condicion/CondicionCrear.vue'),
        meta: { requiresAuth: true, roles: ['admin','operaciones'] }
      },
      {
        path: 'condiciones/detalle/:id',
        name: 'condicion-detalle',
        component: () => import('@/views/Condicion/CondicionDetalle.vue'),
        meta: { requiresAuth: true, roles: ['visita', 'admin','operaciones','ventas inex'] }
      },
      {
        path: 'taxonomias',
        name: 'taxonomias',
        component: () => import('@/views/Taxonomia/TaxonomiaView.vue'),
        meta: { requiresAuth: true, roles: ['visita', 'admin','operaciones','ventas inex'] }
      },
      {
        path: 'taxonomias/crear',
        name: 'taxonomia-crear',
        component: () => import('@/views/Taxonomia/TaxonomiaCrear.vue'),
        meta: { requiresAuth: true, roles: ['admin','operaciones'] }
      },
      {
        path: 'taxonomias/detalle',
        name: 'taxonomia-detalle',
        component: () => import('@/views/Taxonomia/TaxonomiaDetalle.vue'),
        meta: { requiresAuth: true, roles: ['visita', 'admin','operaciones','ventas inex'] }
      },
      {
        path: 'imagenes-categorias',
        name: 'imagenes-categorias',
        component: () => import('@/views/CategoriaImagen/CategoriaImagenView.vue'),
        meta: { requiresAuth: true, roles: ['visita', 'admin','operaciones','ventas inex'] }
      },
      {
        path: 'holdings',
        name: 'holdings',
        component: () => import('@/views/Holding/HoldingView.vue'),
        meta: { requiresAuth: true, roles: ['visita', 'admin','ventas inex','operaciones'] }
      },
      {
        path: 'holdings/crear',
        name: 'holding-crear',
        component: () => import('@/views/Holding/HoldingCrear.vue'),
        meta: { requiresAuth: true, roles: ['admin','operaciones'] }
      },
      {
        path: 'holdings/detalle/:id',
        name: 'holding-detalle',
        component: () => import('@/views/Holding/HoldingDetalle.vue'),
        meta: { requiresAuth: true, roles: ['visita', 'admin','ventas inex','operaciones'] }
      },
      {
        path: 'tipos-cambio',
        name: 'tipos-cambio',
        component: () => import('@/views/TipoCambio/TipoCambioView.vue'),
        meta: { requiresAuth: true, roles: ['visita', 'admin','ventas inex','operaciones'] }
      },
      {
        path: 'tipos-cambio/crear',
        name: 'tipo-cambio-crear',
        component: () => import('@/views/TipoCambio/TipoCambioCrear.vue'),
        meta: { requiresAuth: true, roles: ['admin','operaciones'] }
      },
      {
        path: 'tipos-cambio/detalle/:fecha',
        name: 'tipo-cambio-detalle',
        component: () => import('@/views/TipoCambio/TipoCambioDetalle.vue'),
        meta: { requiresAuth: true, roles: ['visita', 'admin','ventas inex','operaciones'] }
      },
      {
        path: 'perfil',
        name: 'usuario-perfil',
        component: () => import('@/views/Usuario/UsuarioPerfil.vue'),
        meta: { requiresAuth: true, roles: ['visita', 'admin','ventas inex','operaciones','comprador','cliente'] }
      },
      {
        path: 'clientes',
        name: 'clientes',
        component: () => import('@/views/Empresa/EmpresaView.vue'),
        meta: { requiresAuth: true, roles: ['visita', 'admin','ventas inex','operaciones'] }
      },
      {
        path: 'clientes/crear',
        name: 'empresa-crear',
        component: () => import('@/views/Empresa/EmpresaCrear.vue'),
        meta: { requiresAuth: true, roles: ['admin','ventas inex','operaciones'] }
      },
      {
        path: 'clientes/detalle/:id',
        name: 'empresa-detalle',
        component: () => import('@/views/Empresa/EmpresaDetalle.vue'),
        meta: { requiresAuth: true, roles: ['visita', 'admin','ventas inex','operaciones']}
      },
      // ——— Módulos: sin acceso para el perfil "cliente" (tampoco por URL directa) ———
      {
        path: 'materiales',
        name: 'materiales',
        component: () => import('@/views/Materiales/MaterialesView.vue'),
        meta: { requiresAuth: true, roles: ['visita', 'admin', 'ventas inex', 'operaciones'] }
      },
      {
        path: 'materialesResultFile/:token',
        name: 'materiales-result-file',
        component: () => import('@/views/Materiales/MaterialesResultFile.vue'),
        meta: { requiresAuth: true, roles: ['visita', 'admin', 'ventas inex', 'operaciones'] }
      },
      {
        path: 'rentabilizacion',
        name: 'rentabilizacion',
        component: () => import('@/views/Rentabilizacion/RentabilizacionView.vue'),
        meta: { requiresAuth: true, roles: ['visita', 'admin','ventas inex', 'operaciones'] }
      },
      {
        path: 'clusterizacion',
        name: 'clusterizacion',
        component: () => import('@/views/Clusterizacion/ClusterizacionView.vue'),
        meta: { requiresAuth: true, roles: ['visita', 'admin','ventas inex','operaciones'] }
      },
      {
        path: '/lectura-ventas-inventario',
        name: 'LecturaVentasInventario',
        component: () => import('@/views/Clusterizacion/LecturaVentasInventarioView.vue'),
        meta: { requiresAuth: true, roles: ['visita', 'admin','ventas inex','operaciones'] }
      },
      {
        path: "/cluster-detalle",
        name: "ClusterDetalle",
        component: () => import("@/views/Clusterizacion/ClusterDetalleView.vue"),
        meta: { requiresAuth: true, roles: ['visita', 'admin','ventas inex','operaciones'] }
      },
      {
        path: 'visor-transacciones',
        name: 'visor-transacciones',
        component: () => import('@/views/Transacciones/VisorTransacciones.vue'),
        meta: { requiresAuth: true, roles: ['visita', 'admin','ventas inex','operaciones','comprador','cliente'] }
      },
      {
        path: 'ofertas',
        name: 'ofertas',
        component: () => import('@/views/Transacciones/OfertasView.vue'),
        meta: { requiresAuth: true, roles: ['visita', 'admin','ventas inex','operaciones'] }
      },
      {
        path: 'solicitudes',
        name: 'solicitudes',
        component: () => import('@/views/Transacciones/SolicitudesView.vue'),
        meta: { requiresAuth: true, roles: ['visita', 'admin','ventas inex','operaciones'] }
      },
      {
        path: 'mis-solicitudes',
        name: 'mis-solicitudes',
        component: () => import('@/views/Transacciones/SolicitudesClienteView.vue'),
        meta: { requiresAuth: true, roles: ['comprador','cliente'] }
      }
      /*{
        path: 'clientes',
        name: 'clientes',
        component: () => import('@/views/Clientes/ClienteView.vue'),
        meta: { requiresAuth: true, roles: ['visita', 'admin', 'ventas inex'] }
      }*/
    ]
  },

  // ——— Vista pública de ficha (sin auth) ———
  {
    path: '/ficha-publica/:idFicha',
    name: 'FichaPublica',
    component: () => import('@/views/Ficha/FichaDetallePublico.vue')
  },

  // ——— Puente desde el PDF: abre la ficha pública en una pestaña nueva (sin auth) ———
  {
    path: '/abrir-ficha/:idFicha',
    name: 'AbrirFichaPublica',
    component: () => import('@/views/Ficha/AbrirFichaPublica.vue')
  },

  // ——— Catch-all 404 ———
  {
    path: '*',
    name: 'error',
    component: NotFound
  }
];